import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

$w.onReady(function () {
    let path = wixLocation.path;
    console.log("完整的URL路径:", path);

    if (path.length === 2) {
        let userId = path[0]; // 用户ID
        let questionId = path[1]; // 问题ID

        console.log("提取的userId:", userId);
        console.log("提取的questionId:", questionId);

        loadQuestionData(questionId);
        loadAnswerData(userId, questionId);

        // 添加收藏按钮点击事件
        $w("#saveButton").onClick(() => {
            saveQuestion(userId, questionId);
        });

        // 添加上一题按钮点击事件
        $w("#prevButton").onClick(() => {
            navigateToPreviousQuestion(userId, questionId);
        });

        // 添加下一题按钮点击事件
        $w("#nextButton").onClick(() => {
            navigateToNextQuestion(userId, questionId);
        });
    } else {
        console.error('User ID or Question ID is missing from URL parameters.');
    }
});

function loadQuestionData(questionId) {
    wixData.query('SQE1AIBasedMCQBank')
        .eq('_id', questionId)
        .find()
        .then((results) => {
            if (results.items.length > 0) {
                const item = results.items[0];
                console.log("Question Data:", item);
                $w("#text134").html = item.xingQuestionId;
                $w("#radioGroup1").options = [
                    { label: item.optionA, value: 'A' },
                    { label: item.optionB, value: 'B' },
                    { label: item.optionC, value: 'C' },
                    { label: item.optionD, value: 'D' },
                    { label: item.optionE, value: 'E' }
                ];
                $w("#text136").html = item.xingAnswerId;

                if (Array.isArray(item.subject)) {
                    $w('#selectionTags1').options = item.subject.map(subject => ({
                        label: subject,
                        value: subject
                    }));
                } else {
                    console.error('Subject field is not in expected format');
                }
            } else {
                console.error('No question found with the given ID.');
            }
        })
        .catch((err) => {
            console.error('Failed to load question data:', err);
        });
}

function loadAnswerData(userId, questionId) {
    // 清除 section6 和 section8 的显示状态
    $w('#section6').hide();
    $w('#section8').hide();

    wixData.query('SQE1studentanswers')
        .eq('userId', userId)
        .eq('questionId', questionId)
        .find()
        .then((results) => {
            if (results.items.length > 0) {
                const item = results.items[0];
                console.log("Answer Data:", item);
                $w('#timerDisplay').text = item.durationMCQ;
                let resultMessage = "";
                if (item.isCorrect) {
                    resultMessage = "<span style='color: darkgreen; font-size: 16px; text-align: center; display: block;'>You have chosen the correct answer</span>";
                } else {
                    resultMessage = "<span style='color: darkred; font-size: 16px; text-align: center; display: block;'>You have chosen the incorrect answer.</span>";
                }
                
                // 添加选择的选项信息
                resultMessage += `<br><span style='font-size: 16px; text-align: center; display: block;'>Your selected option: ${item.selectedOption}</span>`;
                
                $w('#text374').html = resultMessage;

                }

        })
        .catch((err) => {
            console.error('Failed to load answer data:', err);
        });


    wixData.query('SQE1studentanswersplusqa')
        .eq('userId', userId)
        .eq('questionId', questionId)
        .find()
        .then((results) => {
            if (results.items.length > 0) {
                const item = results.items[0];
                console.log("QA Data:", item);

                if (item.userContent && item.userContent.trim() !== "") {
                    $w('#section6').show();
                    $w('#userContent').text = item.userContent;
                } else {
                    $w('#section6').hide();
                }

                if (item.aiResponse && item.aiResponse.trim() !== "") {
                    $w('#section8').show();
                    $w('#aiContent').text = item.aiResponse;
                } else {
                    $w('#section8').hide();
                }
            }
        })
        .catch((err) => {
            console.error('Failed to load AI response data:', err);
        });
}

function saveQuestion(userId, questionId) {
    wixData.insert('SQE1SaveCollection', {
        userId: userId,
        questionId: questionId
    })
    .then(() => {
        console.log('Question saved successfully');
        $w('#feedbackText123').show();
        $w('#feedbackText123').html = "<span style='color: darkgreen; font-size: 16px; text-align: center; display: block;'>Saved successfully</span>";
    })
    .catch((err) => {
        console.error('Failed to save question:', err);
        $w('#feedbackText123').show();
        $w('#feedbackText123').html = "<span style='color: darkred; font-size: 16px; text-align: center; display: block;'>Save failed, please try again</span>";
    });
}

function navigateToPreviousQuestion(userId, questionId) {
    wixData.query('SQE1studentanswers')
        .eq('userId', userId)
        .ascending('_createdDate')
        .find()
        .then((results) => {
            const items = results.items;
            const currentIndex = items.findIndex(item => item.questionId === questionId);
            console.log("Current Index:", currentIndex);
            if (currentIndex > 0) {
                const previousQuestionId = items[currentIndex - 1].questionId;
                console.log("Previous Question ID:", previousQuestionId);
                wixLocation.to(`/reviewyoursqerecords/${userId}/${previousQuestionId}`);
            } else {
                console.log('No previous question available.');
            }
        })
        .catch((err) => {
            console.error('Failed to navigate to the previous question:', err);
        });
}

function navigateToNextQuestion(userId, questionId) {
    wixData.query('SQE1studentanswers')
        .eq('userId', userId)
        .ascending('_createdDate')
        .find()
        .then((results) => {
            const items = results.items;
            const currentIndex = items.findIndex(item => item.questionId === questionId);
            console.log("Current Index:", currentIndex);
            if (currentIndex < items.length - 1) {
                const nextQuestionId = items[currentIndex + 1].questionId;
                console.log("Next Question ID:", nextQuestionId);
                wixLocation.to(`/reviewyoursqerecords/${userId}/${nextQuestionId}`);
            } else {
                console.log('No next question available.');
            }
        })
        .catch((err) => {
            console.error('Failed to navigate to the next question:', err);
        });
}
